import { API_CALL } from '../../middleware/api';

export const EDIT_PATIENT_ACTION_MODAL_NAME = 'edit-patient-action';

export const LIST_PATIENT_ACTIONS = 'LIST_PATIENT_ACTIONS';
export const LIST_PATIENT_ACTIONS_RESULT = `${LIST_PATIENT_ACTIONS}/result`;
export const PATCH_PATIENT_ACTION = 'PATCH_PATIENT_ACTION';
export const PATCH_PATIENT_ACTION_RESULT = `${PATCH_PATIENT_ACTION}/result`;
export const SET_PATIENT_ACTION_STATUS = 'SET_PATIENT_ACTION_STATUS';
export const SET_PATIENT_ACTION_STATUS_RESULT = `${SET_PATIENT_ACTION_STATUS}/result`;
export const GET_NOTE_HISTORY = 'GET_NOTE_HISTORY';
export const GET_NOTE_HISTORY_RESULT = `${GET_NOTE_HISTORY}/result`;
export const SEARCH_ACTION_ASSIGNEES = 'SEARCH_ACTION_ASSIGNEES';
export const SEARCH_ACTION_ASSIGNEES_RESULT = `${SEARCH_ACTION_ASSIGNEES}/result`;
export const RECHECK_ACCESS_ELIGIBILITY = 'RECHECK_ACCESS_ELIGIBILITY';
export const RECHECK_ACCESS_ELIGIBILITY_RESULT = `${RECHECK_ACCESS_ELIGIBILITY}/result`;

export const CARE_UPDATE_ACTION_TYPES = ['access_care_initiation', 'access_care_escalation', 'access_care_completion'];

export const ACCESS_ACTION_TYPES = [
  ...CARE_UPDATE_ACTION_TYPES,
  'not_eligible_ack',
  'proceed_to_alignment',
  'proceed_to_switch',
  'data_mismatch',
  'recheck_window_expired',
];
export const ACCESS_TRACKS = ['CKM', 'eCKM', 'MSK', 'BH'];

export const actions = {
  // latest: each list (assigned / unassigned) owns its own request key, so a
  // slow stale response never overwrites a newer one.
  listActions: (listKey, params) => ({
    [API_CALL]: { method: 'GET', endpoint: 'portal/patients/actions', params, latest: `patient-actions-${listKey}` },
    type: LIST_PATIENT_ACTIONS,
  }),
  patchAction: (noteId, data) => ({
    [API_CALL]: { method: 'PATCH', endpoint: `portal/patients/note/${noteId}/action`, data },
    type: PATCH_PATIENT_ACTION,
  }),
  setActionStatus: (noteId, completed, resolution) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/patients/note/${noteId}/action-status`,
      data: resolution ? { action_completed: completed, resolution } : { action_completed: completed },
    },
    type: SET_PATIENT_ACTION_STATUS,
  }),
  // A new CMS ACCESS eligibility check of an ACCESS action's enrollment, e.g.
  // after correcting the data a mismatch action asks for.
  recheckAccessEligibility: enrollmentId => ({
    [API_CALL]: { method: 'POST', endpoint: `portal/cmmi-access/enrollment/${enrollmentId}/eligibility/check`, data: {} },
    type: RECHECK_ACCESS_ELIGIBILITY,
  }),
  getNoteHistory: noteId => ({
    [API_CALL]: { method: 'GET', endpoint: `portal/patients/note/${noteId}/history` },
    type: GET_NOTE_HISTORY,
  }),
  // Users an action can be assigned to: everyone when patientId is omitted
  // (the assignee filter), or only those who can see that patient.
  searchAssignees: patientId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/patients/search-for-note-recipients',
      params: patientId ? { include_self: true, patient: patientId } : { include_self: true },
    },
    type: SEARCH_ACTION_ASSIGNEES,
  }),
};

export const priorityLabel = priority => {
  switch (priority) {
    case 2:
      return 'high';
    case 1:
      return 'medium';
    default:
      return 'low';
  }
};

export const errorMessage = (response, fallback) => (
  response?.response?.data?.standard_error?.message
  || response?.response?.data?.error?.message
  || fallback
);
